import * as types from "redux/constants/common";

export const addGlobalMessageSuccess = payload => ({
	type: types.ADD_GLOBAL_SUCCESS_MESSAGE,
	payload,
});
